import * as React from "react";

import {
  DataSourceMyBagQueryProvider,
  DataSourceMyBagQueryProviderProps,
} from "./data-source--mybag-query-provider";

export interface DataSourceMyBagControllerConsumerInterface {
  desiredCart?: DataSourceMyBagQueryProviderProps;
  request: (desiredCart: DataSourceMyBagQueryProviderProps) => void;
}

const defaultValue =
  {} as unknown as DataSourceMyBagControllerConsumerInterface;

const DataSourceMyBagControllerContext = React.createContext(defaultValue);

export const DataSourceMyBagControllerProvider: React.FunctionComponent = (
  props
) => {
  const [desiredCart, setDesiredCart] =
    React.useState<DataSourceMyBagQueryProviderProps>();

  const request: DataSourceMyBagControllerConsumerInterface["request"] =
    React.useCallback((desiredCart) => {
      setDesiredCart(desiredCart);
    }, []);

  const value: DataSourceMyBagControllerConsumerInterface = React.useMemo(
    () => ({
      request,
      desiredCart,
    }),
    [request, desiredCart]
  );

  return (
    <DataSourceMyBagControllerContext.Provider value={value}>
      {desiredCart ? (
        <DataSourceMyBagQueryProvider
          isCustomerLoggedIn={desiredCart.isCustomerLoggedIn}
          cartId={desiredCart.cartId}
          useInitialState={desiredCart.useInitialState}
        >
          {props?.children || []}
        </DataSourceMyBagQueryProvider>
      ) : (
        <React.Fragment>{props?.children || []}</React.Fragment>
      )}
    </DataSourceMyBagControllerContext.Provider>
  );
};

export const useDataSourceMyBagController = () => {
  const context = React.useContext(DataSourceMyBagControllerContext);
  if (context === defaultValue) {
    throw new Error(
      "useDataSourceMyBagController must be used within a DataSourceMyBagControllerProvider"
    );
  }
  return context;
};
